import { useQuery } from '@tanstack/vue-query'
import { toValue, type MaybeRefOrGetter } from 'vue'
import { propertyKeys } from '../propertyQueryKeys'
import { getPropertyCoOwners } from '../propertyEndpoints'

export function usePropertyCoOwnersQuery(id: MaybeRefOrGetter<string>) {
  return useQuery({
    queryKey: () => propertyKeys.coOwners(toValue(id)),
    queryFn: () => getPropertyCoOwners(toValue(id)),
    enabled: () => Boolean(toValue(id)),
  })
}
